module.exports = __webpack_public_path__ + "img/icon-car.324675d3.svg";